import * as React from 'react';
import hopeTheme from './themes/hopeTheme';

interface largeButtonProps {
  bgColor: string;
  borderColor?: string;
  hoverColor: string;
  textColor: string;
}

/* LARGE BUTTONS */
const largeButtonStyle = {
  height: 48,
  borderRadius: 1,
  zIndex: 0,
} as React.CSSProperties;

const largeButtonLabelStyle = {
  whiteSpace: 'nowrap',
  fontSize: 16,
  letterSpacing: 2,
  fontFamily: hopeTheme.fontFamily,
  textTransform: 'uppercase',
} as React.CSSProperties;

const largeButtonLabelStyleLightWeight = {
  ...largeButtonLabelStyle,
  fontWeight: hopeTheme.weightLight,
} as React.CSSProperties;

const largeButtonLabelStyleMediumWeight = {
  ...largeButtonLabelStyle,
  fontWeight: hopeTheme.weightMedium,
} as React.CSSProperties;

export const largeButton = (props: largeButtonProps) => {
  const { borderColor, bgColor, textColor, hoverColor } = props;
  const border = borderColor ? `1px solid ${borderColor}` : `none`;

  return {
    hoverColor,
    backgroundColor: bgColor,
    rippleColor: 'white',
    style: {
      ...largeButtonStyle,
      padding: '0 60px',
      border,
    },
    labelStyle: {
      ...largeButtonLabelStyleMediumWeight,
      color: textColor,
    },
  };
};

export const largeButtonBlack = {
  style: {
    ...largeButtonStyle,
    padding: '0 60px',
    border: '1px solid #0a0a0a',
  },
  backgroundColor: 'transparent',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeBlack,
  },
  rippleColor: 'white',
} as React.CSSProperties;

export const largeButtonBlackWide = {
  style: {
    ...largeButtonStyle,
    padding: '0 6%',
    border: '1px solid #0a0a0a',
  },
  backgroundColor: 'transparent',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeBlack,
  },
  rippleColor: 'white',
} as React.CSSProperties;

export const largeButtonPurple = {
  style: {
    ...largeButtonStyle,
    padding: '0 60px',
    border: '0px solid #784cab',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
};

export const largeButtonPurpleFullWidth = {
  style: {
    ...largeButtonStyle,
    width: '100%',
    border: '0px solid #784cab',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

const largeButtonPurpleMenuFontWeight = 500 as 500;

export const largeButtonPurpleMenu = {
  style: {
    ...largeButtonStyle,
    width: '175px',
    border: '1px solid #784cab',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    fontWeight: largeButtonPurpleMenuFontWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const largeButtonPurpleMenuMobile = {
  style: {
    ...largeButtonStyle,
    width: '100%',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    fontWeight: largeButtonPurpleMenuFontWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;
const largeButtonWhiteMenuFontWeight = 600 as 600;

export const largeButtonWhiteMenu = {
  style: {
    ...largeButtonStyle,
    width: '175px',
    border: '1px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    fontWeight: largeButtonWhiteMenuFontWeight,
    color: hopeTheme.hopeLightPurple,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhiteMenuMobile = {
  style: {
    ...largeButtonStyle,
    width: '100%',
    border: '1px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    fontWeight: largeButtonWhiteMenuFontWeight,
    color: hopeTheme.hopeLightPurple,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonPurpleMobile = {
  style: {
    ...largeButtonStyle,
    padding: '0px 20px',
    minWidth: 200,
    border: '0px solid #784cab',
  } as React.CSSProperties,
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
};

export const largeButtonPurpleMobileNoPadding = {
  style: {
    ...largeButtonStyle,
    padding: '0 10px',
    border: '0px solid #784cab',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const largeButtonWhite = {
  style: {
    ...largeButtonStyle,
    padding: '0 10%',
    border: '1px solid white',
  },
  backgroundColor: 'transparent',
  labelStyle: {
    ...largeButtonLabelStyleLightWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhiteFullWidth = {
  style: {
    ...largeButtonStyle,
    width: '100%',
    border: '1px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeLightPurple,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhiteBlack = {
  style: {
    ...largeButtonStyle,
    padding: '0 60px',
    minWidth: '260px',
    border: 'white',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeBlack,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhitePurple = {
  style: {
    ...largeButtonStyle,
    padding: '0 3%',
    minWidth: '260px',
    border: '1px solid white',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeLightPurple,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhitePurpleNoOutline = {
  style: {
    ...largeButtonStyle,
    padding: '0 3%',
    minWidth: '260px',
    border: '0px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeBlack,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhitePurpleNoOutlineMobile = {
  style: {
    ...largeButtonStyle,
    padding: '0 3%',
    border: '0px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeBlack,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonWhitePurpleMobile = {
  style: {
    ...largeButtonStyle,
    padding: '0 3%',
    border: '1px solid #784cab',
  },
  backgroundColor: 'white',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: hopeTheme.hopeLightPurple,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const largeButtonOrange = {
  style: {
    ...largeButtonStyle,
    padding: '0 60px',
    border: '0px solid #784cab',
  } as React.CSSProperties,
  backgroundColor: '#F4554E',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: '#C70000',
};

export const largeButtonOrangeMobile = {
  style: {
    ...largeButtonStyle,
    padding: '0px 10px',
    minWidth: 200,
    border: '0px solid #784cab',
  } as React.CSSProperties,
  backgroundColor: '#F4554E',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  },
  rippleColor: 'white',
  hoverColor: '#C70000',
};

export const largeButtonOrangeFullWidth = {
  style: {
    ...largeButtonStyle,
    width: '100%',
    border: '0px solid #784cab',
  },
  backgroundColor: '#F4554E',
  labelStyle: {
    ...largeButtonLabelStyleMediumWeight,
    color: 'white',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: '#C70000',
} as React.CSSProperties;

export const largeButtonDisabled = {
  style: {
    ...largeButtonStyle,
    padding: '0 50px',
    border: 0,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    ...largeButtonLabelStyle,
    color: 'white',
  },
  rippleColor: 'white',
} as React.CSSProperties;

export const largeButtonDisabledFullWidth = {
  style: {
    ...largeButtonStyle,
    width: '100%',
    border: 0,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    ...largeButtonLabelStyle,
    color: 'white',
  },
  rippleColor: 'white',
} as React.CSSProperties;

/* MEDIUM BUTTONS */

export const mediumButtonPurple = {
  style: {
    padding: '0 20px',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeBlack,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight as 'normal',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightBlack,
} as React.CSSProperties;

export const mediumButtonOrange = {
  style: {
    padding: '0 20px',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: '#F4554E',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight as 'normal',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: '#C70000',
} as React.CSSProperties;

export const mediumButtonGrey = {
  ...mediumButtonPurple,
  backgroundColor: hopeTheme.hopeLightGrey,
  hoverColor: '#c6c6c6',
} as React.CSSProperties;

export const mediumButtonPurpleFullWidth = {
  style: {
    width: '100%',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const mediumButtonLuxPurpleFullWidth = {
  style: {
    width: '100%',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLuxPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightPurple,
} as React.CSSProperties;

export const mediumButtonWhite = {
  style: {
    height: 44,
    padding: '0 20px',
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const mediumButtonWhiteFullWidth = {
  style: {
    width: '100%',
    height: 44,
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const mediumButtonDisabled = {
  style: {
    padding: '0 20px',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 16,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const mediumButtonDisabledFullWidth = {
  style: {
    width: '100%',
    height: 44,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 16,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

/* SMALL BUTTONS */

export const smallButtonPurple = {
  style: {
    padding: '0 20px',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const smallButtonOrange = {
  style: {
    padding: '0 20px',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: '#F4554E',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: '#C70000',
} as React.CSSProperties;

export const smallButtonGrey = {
  style: {
    padding: '0 20px',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: '#c6c6c6',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const smallButtonPurpleFixedWidth = {
  style: {
    padding: '0 20px',
    height: 40,
    border: 0,
    borderRadius: 1,
    width: '100%',
    maxWidth: 275,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const smallButtonPurpleFullWidth = {
  style: {
    width: '100%',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const smallButtonWhite = {
  style: {
    height: 40,
    padding: '0 20px',
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const smallButtonWhiteBlack = {
  style: {
    height: 40,
    padding: '0 20px',
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeBlack,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const addToCartButtonInactive = {
  style: {
    width: '100%',
    height: 40,
    border: 'none',
    // borderRight: 'none',
    // borderLeft: 'none',
    // borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeBlack,
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: hopeTheme.headerBold,
    fontWeight: hopeTheme.weightBold,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const smallButtonWhiteFullWidth = {
  style: {
    width: '100%',
    height: 40,
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const smallButtonWhiteFixedWidth = {
  style: {
    width: '100%',
    height: 40,
    border: '1px solid #784cab',
    borderRadius: 1,
    maxWidth: 275,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const smallButtonDisabled = {
  style: {
    padding: '0 20px',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 14,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const smallButtonDisabledFullWidth = {
  style: {
    width: '100%',
    height: 40,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 14,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const smallButtonDisabledFixedWidth = {
  style: {
    height: 40,
    border: 0,
    borderRadius: 1,
    width: '100%',
    maxWidth: 275,
    cursor: 'auto',
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 14,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'none',
  hoverColor: 'none',
} as React.CSSProperties;

/* EXTRA-SMALL BUTTONS */

export const extraSmallButtonBlack = {
  style: {
    maxWidth: 120,
    height: 40,
    border: 0,
    borderRadius: 4,
  },
  backgroundColor: '#1a1a1a',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 12,
    lineHeight: 1.67,
    letterSpacing: 1,
    paddingLeft: 0,
    paddingRight: 0,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const extraSmallButtonPurple = {
  style: {
    maxWidth: 100,
    height: 36,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const extraSmallButtonPurpleFullWidth = {
  style: {
    width: '100%',
    height: 36,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const extraSmallButtonWhite = {
  style: {
    height: 36,
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: hopeTheme.hopeLuxPurple,
  hoverColor: hopeTheme.hopeTextGrey,
} as React.CSSProperties;

export const extraSmallButtonWhiteGrey = {
  style: {
    width: 120,
    height: 40,
    border: `1px solid #a9a9a9`,
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeTextGrey,
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: hopeTheme.hopeLuxPurple,
  hoverColor: '#e6e6e6',
} as React.CSSProperties;

export const extraSmallButtonOrange = {
  style: {
    width: 120,
    height: 40,
    border: `1px solid #F4554E`,
    borderRadius: 1,
  } as React.CSSProperties,
  backgroundColor: '#F4554E',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: '#C70000',
};

export const extraSmallButtonGray = {
  style: {
    width: 120,
    height: 40,
    border: `1px solid #a9a9a9`,
    borderRadius: 1,
  },
  backgroundColor: '#a9a9a9',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: '#c6c6c6',
} as React.CSSProperties;

export const extraSmallButtonWhiteFullWidth = {
  style: {
    width: '100%',
    height: 36,
    border: '1px solid #784cab',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 0.5,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: hopeTheme.hopeLuxPurple,
  hoverColor: hopeTheme.hopeTextGrey,
} as React.CSSProperties;

export const extraSmallButtonDisabled = {
  style: {
    height: 36,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 14,
    letterSpacing: 0.5,
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const extraSmallButtonDisabledFullWidth = {
  style: {
    width: '100%',
    height: 36,
    border: 0,
    borderRadius: 1,
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: 14,
    letterSpacing: 0.5,
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

/* BLUE LINK BUTTONS */

export const largeLinkButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    letterSpacing: 1,
  },
  style: {
    padding: 0,
    borderRadius: 0,
    marginLeft: -16,
    border: 0,
  },
  rippleColor: 'none',
  hoverColor: 'white',
} as React.CSSProperties;

export const mediumLinkButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    letterSpacing: 0.5,
  },
  style: {
    padding: 0,
    minWidth: 55,
    borderRadius: 0,
    marginLeft: -16,
    border: 0,
  },
  rippleColor: 'none',
  hoverColor: 'white',
} as React.CSSProperties;

export const mediumLinkButtonClearBackground = {
  // backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    letterSpacing: 0.5,
  },
  style: {
    padding: 0,
    minWidth: 55,
    borderRadius: 0,
    marginLeft: -16,
    border: 0,
  },
  rippleColor: 'none',
  hoverColor: 'none',
} as React.CSSProperties;

export const smallLinkButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 12,
    fontWeight: 550,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    letterSpacing: 0.5,
  },
  style: {
    padding: 0,
    borderRadius: 0,
    marginLeft: -16,
    border: 0,
  },
  rippleColor: 'none',
  hoverColor: 'white',
} as React.CSSProperties;

export const blueLinkButton = {
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    letterSpacing: 0.5,
  },
  style: {
    padding: 0,
    marginLeft: -14,
    borderRadius: 0,
    border: 'none',
  },
  rippleColor: 'none',
  hoverColor: 'none',
};

export const adjustLeftBlueLinkButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    letterSpacing: 0.5,
  },
  style: {
    padding: 0,
    height: 28,
    marginLeft: -14,
    borderRadius: 0,
    border: 'none',
  },
  rippleColor: 'none',
  hoverColor: 'none',
} as React.CSSProperties;

export const adjustRightBlueLinkButton = {
  style: {
    marginTop: -36,
    marginRight: -20,
    border: '0px solid #784cab',
    borderRadius: 0,
  },
  backgroundColor: 'transparent',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 12,
    letterSpacing: 0.5,
    fontWeight: 600,
    textTransform: 'none',
  },
  rippleColor: 'none',
  hoverColor: 'none',
} as React.CSSProperties;

/* SPECIALTY BUTTONS */

export const addToCartButton = {
  style: {
    width: '100%',
    height: 40,
    border: 'none',
    borderRadius: 0,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 14,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const addToCartButtonBlack = {
  style: {
    width: '100%',
    height: 40,
    border: 'none',
    borderRadius: 0,
  },
  backgroundColor: hopeTheme.hopeBlack,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 1,
    lineHeight: '20px',
    fontFamily: hopeTheme.headerBold,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeBlack,
} as React.CSSProperties;

export const addToCartButtonPurple = {
  style: {
    width: '100%',
    height: 40,
    border: 'none',
    borderRadius: 0,
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 1,
    lineHeight: '20px',
    fontFamily: hopeTheme.headerBold,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightPurple,
} as React.CSSProperties;

export const addToCartButtonBlue = {
  style: {
    width: '100%',
    height: 40,
    border: 'none',
    borderRadius: 0,
  },
  backgroundColor: hopeTheme.hopeToyBlue,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 15,
    letterSpacing: 1,
    lineHeight: '20px',
    fontFamily: hopeTheme.headerBold,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeToyBlue,
} as React.CSSProperties;

export const checkoutButtonDisabled = {
  style: {
    width: '100%',
    height: 75,
    border: '0px solid #49D49D',
    borderRadius: '0px',
  },
  backgroundColor: '#eee',
  labelStyle: {
    color: 'aaa',
    textTransform: 'uppercase',
    fontSize: 24,
    letterSpacing: 3,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeWinePurple,
} as React.CSSProperties;

export const newsLetterSignUp = {
  style: {
    width: 285,
    padding: '0 20px',
    height: 48,
    border: '1px solid white',
    borderRadius: 1,
    margin: '0 auto',
    textAlign: 'center',
    zIndex: 0,
  },
  backgroundColor: 'transparent',
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: 'none',
} as React.CSSProperties;

export const shippingInfoButton = {
  style: {
    width: 285,
    padding: '0 20px',
    height: 48,
    border: '1px solid #784cab',
    borderRadius: 1,
    margin: '0 auto',
    textAlign: 'center',
    zIndex: 0,
  } as React.CSSProperties,
  backgroundColor: 'transparent',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  } as React.CSSProperties,
  rippleColor: 'white',
};

export const mobileShippingInfoButton = {
  style: {
    ...shippingInfoButton.style,
  } as React.CSSProperties,
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    ...shippingInfoButton.labelStyle,
    color: '#fff',
  } as React.CSSProperties,
  rippleColor: shippingInfoButton.rippleColor,
};

export const checkoutButton = {
  style: {
    width: '100%',
    height: 75,
    border: '0px solid #49D49D',
    borderRadius: '0px',
    // backgroundImage: hopeTheme.hopeButtonGradient,
  },
  backgroundColor: hopeTheme.hopeLuxPurple,
  labelStyle: {
    color: 'white',
    fontSize: '22px',
    textTransform: 'none',
    letterSpacing: 3,
    fontFamily: hopeTheme.headerBold,
    fontWeight: 600,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeWinePurple,
} as React.CSSProperties;

export const registerButtonPurple = {
  style: {
    width: 260,
    height: 58,
    borderRadius: 1,
    margin: '0 auto',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.headerBold,
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const signInButtonPurple = {
  style: {
    width: '50%',
    height: 58,
    borderRadius: 1,
    margin: '0 auto',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.headerBold,
    fontWeight: 600,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as any;

export const joinTeamButtonPurple = {
  style: {
    width: '49%',
    height: 58,
    borderRadius: 1,
    margin: '0  1% 0 auto',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.headerBold,
    fontWeight: 600,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const cancelButtonGrey = {
  style: {
    width: '50%',
    height: 58,
    borderRadius: 1,
    margin: '0 auto',
  },
  backgroundColor: '#FAFAFA',
  labelStyle: {
    color: hopeTheme.hopeTextGrey,
    fontFamily: hopeTheme.headerBold,
    fontWeight: 600,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const shopNowButton = {
  style: {
    width: '100%',
    height: 48,
    border: '1px solid #784cab',
    borderRadius: '1px',
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    whiteSpace: 'nowrap',
    fontSize: '16px',
    // textTransform: 'none',
    letterSpacing: 2,
    fontFamily: hopeTheme.headerBold,
    fontWeight: hopeTheme.weightBold,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const writeReviewButton = {
  style: {
    width: '100%',
    maxWidth: 386,
    height: 48,
    border: '0px solid #784cab',
    borderRadius: '1px',
    margin: '0 auto',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: '16px',
    // textTransform: 'none',
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const homePurpleButton = {
  style: {
    width: '100%',
    height: 48,
    border: '0px solid #784cab',
    borderRadius: '1px',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontSize: '16px',
    // textTransform: 'none',
    letterSpacing: 2,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const hopePurpleButtonMenu = {
  styles: {
    padding: '0 60px',
    height: 48,
    border: '1px solid #784cab',
    width: '100%',
    borderRadius: '1px',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: 500,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const hopePurpleButton2 = {
  style: {
    padding: '0 24px',
    height: 44,
    border: '1px solid #784cab',
    cursor: 'pointer',
    borderRadius: '1px',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const hopePurpleButton3 = {
  style: {
    padding: '0 40px',
    height: 40,
    border: '1px solid #784cab',
    cursor: 'pointer',
    borderRadius: '1px',
    margin: '10px 10px',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightLight,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const largeButtonBlue = {
  style: {
    ...largeButtonStyle,
    width: 300,
  },
  backgroundColor: hopeTheme.hopeToyBlue,
  labelStyle: {
    ...largeButtonLabelStyleLightWeight,
    color: 'white',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: 'rgba(12, 115, 212, 1.000)',
} as React.CSSProperties;

export const hopeWhitePurpleButton = {
  style: {
    padding: '0 40px',
    height: 48,
    border: '1px solid #784cab',
    cursor: 'pointer',
    width: '100%',
    borderRadius: '1px',
  } as React.CSSProperties,
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: 1,
  } as React.CSSProperties,
  rippleColor: hopeTheme.hopeLightPurple,
  hoverColor: '#f4f4f4',
};

export const hopeWhitePurpleButtonFullWidth = {
  style: {
    padding: '0 0',
    height: 44,
    border: '1px solid #784cab',
    cursor: 'pointer',
    width: '100%',
    borderRadius: '1px',
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: 1.2,
  },
  rippleColor: hopeTheme.hopeLightPurple,
  hoverColor: '#f4f4f4',
} as React.CSSProperties;

export const cancelButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: 'red',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1.2px',
    textTransform: 'none',
  },
  rippleColor: 'red',
  hoverColor: 'white',
  style: {
    padding: 0,
    height: '28px',
    lineHeight: '1.6em',
    minWidth: 55,
    borderRadius: 1,
    border: '1px solid red',
  },
} as React.CSSProperties;

export const addAllToCart = {
  style: {
    width: '100%',
    verticalAlign: 'middle',
    height: 44,
    border: '1px solid #784cab',
    borderRadius: '1px',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: 0.9,
    lineHeight: '40px',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLuxPurple,
} as React.CSSProperties;

export const resetButton = {
  style: { border: '0px solid #784cab', borderRadius: 0 },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: '12px',
    letterSpacing: 1.5,
    lineHeight: 1.4,
    fontWeight: 600,
    textTransform: 'none',
  },
  rippleColor: hopeTheme.hopeToyBlue,
  hoverColor: 'white',
} as React.CSSProperties;

export const filterByButton = {
  style: {
    height: 44,
    width: '100%',
    borderRadius: '1px',
    border: '1px solid #7a7a7a',
  },
  backgroundColor: '#ffffff',
  labelStyle: {
    color: hopeTheme.textColor,
    fontSize: '14px',
    letterSpacing: 1.8,
    paddingRight: 10,
    paddingLeft: 20,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const sortByMobileButton = {
  style: {
    height: 44,
    width: '100%',
    borderRadius: '1px',
    border: '1px solid #7a7a7a',
  },
  backgroundColor: '#ffffff',
  labelStyle: {
    color: hopeTheme.textColor,
    fontSize: '14px',
    letterSpacing: 1.8,
    paddingRight: 10,
    paddingLeft: 20,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const sortByButton = {
  style: {
    height: 44,
    width: 150,
    borderRadius: '1px',
    border: '1px solid #7a7a7a',
    marginTop: 10,
  },
  backgroundColor: '#ffffff',
  labelStyle: {
    color: hopeTheme.textColor,
    fontSize: '14px',
    letterSpacing: 1.3,
    paddingRight: 5,
    paddingLeft: 20,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterOrdersButton = {
  style: {
    height: 44,
    width: 275,
    borderRadius: '1px',
    border: '1px solid #7a7a7a',
    marginBottom: 10,
  },
  backgroundColor: '#ffffff',
  labelStyle: {
    color: hopeTheme.textColor,
    fontSize: '14px',
    letterSpacing: 1.3,
    paddingRight: 5,
    paddingLeft: 20,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const continueMobileButton = {
  style: {
    height: 64,
    width: 'calc(100% - 12px)',
    borderRadius: '1px',
    border: '1px solid #784cab',
  },
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    fontSize: '16px',
    letterSpacing: 1.2,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeWinePurple,
} as React.CSSProperties;

export const filterCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#7a7a7a',
    fontSize: '16px',
    letterSpacing: 2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterMobileCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#7a7a7a',
    fontSize: '13px',
    letterSpacing: 1.2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterMobileBoldCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#0a0a0a',
    fontSize: '13px',
    letterSpacing: 1.2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterBoldCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#0a0a0a',
    fontSize: '16px',
    letterSpacing: 2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterDisabledMobileCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#ccc',
    fontSize: '13px',
    letterSpacing: 2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const filterDisabledCategory = {
  style: {
    height: 44,
    maxWidth: '100%',
    borderRadius: 'none',
    border: '0px solid #a9a9a9',
  },
  backgroundColor: '#f0f0f0',
  labelStyle: {
    color: '#ccc',
    fontSize: '16px',
    letterSpacing: 2,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: '#7a7a7a',
  hoverColor: '#f0f0f0',
} as React.CSSProperties;

export const promoCodeButton = {
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1.2px',
    textTransform: 'none',
  },
  rippleColor: hopeTheme.hopeToyBlue,
  hoverColor: 'white',
  style: {
    padding: 0,
    height: '28px',
    lineHeight: '1.6em',
    marginRight: -16,
    minWidth: 55,
    borderRadius: 0,
    border: 'none',
  },
} as React.CSSProperties;

export const hopePurpleButtonDisabled = {
  style: {
    padding: '0 8px',
    height: 48,
    border: '1px solid #a9a9a9',
    borderRadius: '1px',
    width: '100%',
  },
  backgroundColor: hopeTheme.hopeTextGrey,
  labelStyle: {
    color: 'white',
    fontSize: '16px',
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
  },
  rippleColor: 'white',
} as React.CSSProperties;

export const staticSmallNavButton = {
  style: {
    padding: '0 0',
    height: 64,
    border: '0px solid #784cab',
    borderRadius: '1px',
  } as React.CSSProperties,
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontFamily: hopeTheme.fontFamily,
    fontWeight: 300,
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeWinePurple,
};

export const staticNavButton = {
  style: {
    padding: '0 10px',
    height: 64,
    border: '0px solid #784cab',
    borderRadius: '1px',
  } as React.CSSProperties,
  backgroundColor: hopeTheme.hopeLightPurple,
  labelStyle: {
    color: 'white',
    whiteSpace: 'nowrap',
    fontFamily: hopeTheme.headerBold,
    fontWeight: 300,
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    paddingLeft: '0',
    paddingRight: '0',
    marginLeft: '16px',
    marginRight: '16px',
  } as React.CSSProperties,
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeWinePurple,
};

export const impactNavButton = {
  style: {
    padding: '0 5px',
    height: 40,
    borderBottom: '1px solid #FAFAFA',
    borderRadius: '1px',
  },
  backgroundColor: '#FAFAFA',
  labelStyle: {
    color: '#A9A9A9',
    fontFamily: hopeTheme.fontFamily,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'capitalize',
  } as React.CSSProperties,
  // rippleColor: '#1A1A1A',
  hoverColor: '#FAFAFA',
} as React.CSSProperties;

export const impactSelectedNavButton = {
  style: {
    padding: '0 5px',
    height: 40,
    borderBottom: '1px solid #1A1A1A',
    borderRadius: '1px',
  },
  backgroundColor: '#FAFAFA',
  labelStyle: {
    color: '#1A1A1A',
    fontFamily: hopeTheme.fontFamily,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'capitalize',
    letterSpacing: 1.2,
  } as React.CSSProperties,
  // rippleColor: '#1A1A1A',
  hoverColor: '#FAFAFA',
} as React.CSSProperties;

export const mediumButtonWhiteBlack = {
  style: {
    width: '100%',
    maxWidth: 350,
    height: 44,
    border: '1px solid #484848',
    borderRadius: 1,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: '#484848',
    whiteSpace: 'nowrap',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightMedium,
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const sliderArrow = {
  icon: {
    width: 48,
    height: 48,
  },
  button: {
    width: 96,
    height: 96,
  },
};

export const extraSmallButtonBlue = {
  style: {
    border: '1px solid #0091ea',
    height: 24,
    lineHeight: 'none',
    borderRadius: 100,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeToyBlue,
    fontSize: 12,
    verticalAlign: 'center',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const extraSmallButtonGrey = {
  style: {
    border: '1px solid #a9a9a9',
    height: 24,
    lineHeight: 'none',
    borderRadius: 100,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeTextGrey,
    fontSize: 12,
    verticalAlign: 'center',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const extraSmallButton = {
  style: {
    border: '1px solid #784cab',
    height: 24,
    lineHeight: 'none',
    borderRadius: 100,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeLightPurple,
    fontSize: 12,
    verticalAlign: 'center',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;

export const extraSmallButtonCancel = {
  style: {
    border: '1px solid #b3192e',
    height: 24,
    lineHeight: 'none',
    borderRadius: 100,
  },
  backgroundColor: 'white',
  labelStyle: {
    color: hopeTheme.hopeRed,
    fontSize: 12,
    verticalAlign: 'center',
    textTransform: 'uppercase',
  },
  rippleColor: 'white',
  hoverColor: hopeTheme.hopeLightGrey,
} as React.CSSProperties;
